import { Modal } from "@/shared/ui/modal"
import WarningSvg from '@/shared/assets/images/Warning.svg'

interface UnverifiedCommunityNotificationModalProps {
    isOpen: boolean
    onClose: () => void
}

export const UnverifiedCommunityNotificationModal: React.FC<UnverifiedCommunityNotificationModalProps> = ({ isOpen, onClose }) => {
    return (
        <Modal
            isOpen={isOpen}
            title="Невозможно добавить карту"
            onRequestClose={onClose}
        >
            <div className="flex flex-col gap-4">
                <div className="flex items-start gap-3">
                    <WarningSvg width={32} height={32} className="mt-1 flex-shrink-0" />
                    <div className="flex flex-col gap-2">
                        <p className="text-base text-color-dark">
                            Для добавления бизнес-карты необходимо, чтобы ваше сообщество было верифицировано.
                        </p>
                        <p className="text-sm text-color-gray">
                            Обратитесь к администратору для прохождения верификации сообщества.
                        </p>
                    </div>
                </div>
                <div className="w-full flex justify-end">
                    <button onClick={onClose} className="form_handle_button">
                        Понятно
                    </button>
                </div>
            </div>
        </Modal>
    )
}

